<script setup lang="ts">
import { markProFormaAsUncollectibe } from '@/api/proFormas';
import SayErrorResponse from '@/mixins/sayErrorResponse';
import Say from '@/utils/Say'
import {inject, onMounted, ref} from "vue";
import {useI18n} from "vue-i18n";

const {t} = useI18n()

const emit = defineEmits(['markedAsUncollectible', 'cancelForm', 'loading'])

const props = defineProps({
  invoice: {
    type: Object,
    required: true
  },
  job: {
    type: Object,
    required: true
  }
})
const form = ref(null as HTMLFormElement | null)
const formValid = ref(false)
const formRules = ref({
  confirmationCheck: [
    value => {
      if (value) return true
      return t('pleaseConfirm')
    },
  ],
  statusReason: [
    value => {
      if (value) return true
      return t('pleaseEnterAReason')
    },
    value => {
      if (value.length <= 128) return true
      return t('reasonMustBe128CharactersOrLess')
    },
    value => {
      if (value.length > 3) return true
      return t('reasonMustBeMoreThan3Characters')
    },
  ],
})
const confirmationCheck = ref(false)

const dialogTitle = inject('dialogTitle', null)
onMounted(() => {
  dialogTitle.value = t('markAsUncollectible')
})

const formSubmitted = ref(false)
const submit = () => {
  if (form.value.validate() && !formValid.value) {
    return
  }
  
  if (formSubmitted.value) {
    return
  }
  formSubmitted.value = true
  emit('loading', true)

  markProFormaAsUncollectibe(props.invoice.id, {status_reason: props.invoice.status_reason})
    .then(response => {
      if (response.data.error) {
        SayErrorResponse(response);
        emit('loading', false)
        formSubmitted.value = false
      } else {
        setTimeout(() => {
          Say('success', t('proFormaSuccessfullyMarkedAsUncollectible'))
          emit('markedAsUncollectible')
          formSubmitted.value = false
        }, 2000)
      }
    })
    .catch(error => {
      SayErrorResponse(error);
      formSubmitted.value = false
      emit('loading', false)
    });
}
const cancel = () => {
  emit('cancelForm')
}
defineExpose({submit, cancel})

const formatDate = (date: string) => {
  const [year, month, day] = date.split('-');
  return `${day.padStart(2, '0')}-${month.padStart(2, '0')}-${year}`;
}
</script>

<template>
  <div>
    <v-form
      v-model="formValid"
      ref="form"
      class="overflow-auto"
    >
      <p class="mb-5" v-if="invoice.id">
        {{ t('period') }}:<br>
        <b>
          {{ formatDate(invoice.start_date) }}
          {{ t('upToAndIncludingAbbreviation') }}
          {{ formatDate(invoice.end_date) }}
        </b>
      </p>
      <p class="mb-5" v-if="invoice.id">
        {{ t('number') }}:<br>
        <b>
          {{ invoice.number }}
        </b>
      </p>

      <!-- status_reason input field -->
      <p class="mb-5">
        <v-text-field
          v-model="invoice.status_reason"
          hide-details
          :label="t('reasonForMarkingAsUncollectible')"
          :placeholder="t('markingAsUncollectiblePlaceholder')"
          variant="underlined"
          :rules="formRules.statusReason"
          />
      </p>

      {{ t('confirmMarkAsUncollectible') }}<br>

      <p class="mt-4">{{$t('toConfirm')}}:</p>

      <v-checkbox
        v-model="confirmationCheck"
        :label="t('markAsUncollectible')"
        :rules="formRules.confirmationCheck"
        hide-details
      />
    </v-form>
  </div>
</template>
